module.exports = __webpack_public_path__ + "img/perfume-editorial.11c01d25.jpg";